import { ReactElement } from 'react';
import { useAuthWrapper } from '@weareopenr/authkit';
import { FEATURE_FLAGS } from 'src/constants';
import { Dashboard } from './Dashboard';
import { LegacyDashboard } from './LegacyDashboard';

const DashboardSwitcher = (): ReactElement => {
  const { featureFlags } = useAuthWrapper();
  const isNewDashboardEnabled = featureFlags.includes(FEATURE_FLAGS.NEW_DASHBOARD);

  return isNewDashboardEnabled ? <Dashboard /> : <LegacyDashboard />;
};

export default DashboardSwitcher;
